/*
- Based on Foundation 6
- Reference https://foundation.zurb.com/sites/docs/media-queries.html
- Usage within styled-components:
  const CustomComponent = styled.div`
    @media screen and (max-width: ${MEDIA_QUERIES.small}) {}

    @media screen and (min-width: ${MEDIA_QUERIES.medium}) {}

    @media screen and (min-width: ${MEDIA_QUERIES.mediumOnly[0]})
      and (max-width: ${MEDIA_QUERIES.mediumOnly[1]}) {}

    @media screen and (min-width: ${MEDIA_QUERIES.large}) {}

    @media screen and (min-width: ${MEDIA_QUERIES.largeOnly[0]})
      and (max-width: ${MEDIA_QUERIES.largeOnly[1]}) {}
`;
*/
export const MEDIA_QUERIES = {
  // Small only
  small: '39.9375em',
  // Medium and up
  medium: '40em',
  // Medium only
  mediumOnly: ['40em', '63.9375em'],
  // Large and up
  large: '64em',
  // Large only
  largeOnly: ['64em', '74.9375em'],
};

export const EDIT_ME = {};


// Brand Tiers
// Basic =>  alias for not_paying
export const BRAND_TIER_FREE_ID = 'not_paying';
// Premium => alias for brand_profile
export const BRAND_TIER_BRAND_PROFILE = 'brand_profile';

export const ANALYTICS = {
  FIND_SIMILAR_ACTION: 'similar_image_search',
  SAVE_IMAGE_ACTION: 'image_saved',
};

export const PAGES_TITLES = {
  FIND_SIMILAR: 'Architizer: Architectural Projects and Design Interiors',
  SAVE_IMAGE: 'Save Image',
};



// WEBPACK FOOTER //
// ./js/src/services/constants.js